import http from "../utils/http"

/**
 * 獲取訂單初始化數據
 * @param {object} params
 */
export function payment(params) {
    return http({
        url: "/groupbuy/api/ordercreate/payment",
        data: params,
        forceLogin: true
    })
}

/**
 * 獲取訂單初始化數據
 * @param {object} params
 */
export function calculate(params) {
    return http({
        url: "/groupbuy/api/ordercreate/calculate",
        data: params,
        forceLogin: true
    })
}

/**
 * 訂單創建
 * @param {object} params
 */
export function orderCreate(params) {
    return http({
        url: "/groupbuy/api/ordercreate/create",
        data: params,
        forceLogin: true
    })
}

/**
 * 商品列表
 * @param {object} params
 */
export function goodsPage(params) {
    return http({
        url: "/groupbuy/api/goods/page",
        data: params,
        forceLogin: true
    })
}

/**
 * 商品詳情
 * @param {object} params
 */
export function goodsSkuDetail(params) {
    return http({
        url: "/groupbuy/api/goods/detail",
        data: params,
        forceLogin: true
    })
}

/**
 * 商品信息
 * @param {object} params
 */
export function goodsSkuInfo(params) {
    return http({
        url: "/groupbuy/api/goods/info",
        data: params,
        forceLogin: true
    })
}



/**
 * 積分商城獲取輪播圖
 * @param {object} params
 */
export function pointsBanner(params) {
    return http({
        url: "/pointexchange/api/goods/banner",
        data: params,
        forceLogin: true
    })
}


/**
 * 積分商品列表
 * @param {object} params
 */
export function pointsGoodsList(params) {
    return http({
        url: "/pointexchange/api/goods/page",
        data: params,
        forceLogin: true
    })
}


/**
 * 積分商品詳情
 * @param {object} params
 */
export function pointsGoodsDetail(params) {
    return http({
        url: "/pointexchange/api/goods/detail",
        data: params,
        forceLogin: true
    })
}

/**
 * 創建積分訂單
 * @param {object} params
 */
export function pointsOrderCreate(params) {
    return http({
        url: "/pointexchange/api/ordercreate/create",
        data: params,
        forceLogin: true
    })
}

/**
 * 支付積分訂單
 * @param {object} params
 */
export function pointsOrderPayment(params) {
    return http({
        url: "/pointexchange/api/ordercreate/payment",
        data: params,
        forceLogin: true
    })
}

/**
 * 積分訂單計算
 * @param {object} params
 */
export function pointsOrderCalculate(params) {
    return http({
        url: "/pointexchange/api/ordercreate/calculate",
        data: params,
        forceLogin: true
    })
}
